/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type { RakeRaceResponse, UserPromotionStatus } from '../models'

import promotionMeRetrieveMutator from '../../client'
import promotionRakeRaceRetrieveMutator from '../../client'

/**
 * Provides a comprehensive status for the authenticated user across all promotions.
 * @summary Get My Promotion Status
 */
export const promotionMeRetrieve = (signal?: AbortSignal) => {
  return promotionMeRetrieveMutator<UserPromotionStatus>({
    url: `/api/v1/promotion/me/`,
    method: 'GET',
    signal,
  })
}

export const getPromotionMeRetrieveQueryKey = () => {
  return [`/api/v1/promotion/me/`] as const
}

export const getPromotionMeRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof promotionMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promotionMeRetrieve>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPromotionMeRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promotionMeRetrieve>>> = ({ signal }) =>
    promotionMeRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof promotionMeRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PromotionMeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof promotionMeRetrieve>>
>
export type PromotionMeRetrieveQueryError = unknown

export function usePromotionMeRetrieve<
  TData = Awaited<ReturnType<typeof promotionMeRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof promotionMeRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof promotionMeRetrieve>>,
        TError,
        Awaited<ReturnType<typeof promotionMeRetrieve>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePromotionMeRetrieve<
  TData = Awaited<ReturnType<typeof promotionMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promotionMeRetrieve>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof promotionMeRetrieve>>,
        TError,
        Awaited<ReturnType<typeof promotionMeRetrieve>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePromotionMeRetrieve<
  TData = Awaited<ReturnType<typeof promotionMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promotionMeRetrieve>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Promotion Status
 */

export function usePromotionMeRetrieve<
  TData = Awaited<ReturnType<typeof promotionMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promotionMeRetrieve>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPromotionMeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getPromotionMeRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof promotionMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof promotionMeRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPromotionMeRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promotionMeRetrieve>>> = ({ signal }) =>
    promotionMeRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof promotionMeRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PromotionMeRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof promotionMeRetrieve>>
>
export type PromotionMeRetrieveSuspenseQueryError = unknown

export function usePromotionMeRetrieveSuspense<
  TData = Awaited<ReturnType<typeof promotionMeRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof promotionMeRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePromotionMeRetrieveSuspense<
  TData = Awaited<ReturnType<typeof promotionMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof promotionMeRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePromotionMeRetrieveSuspense<
  TData = Awaited<ReturnType<typeof promotionMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof promotionMeRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Promotion Status
 */

export function usePromotionMeRetrieveSuspense<
  TData = Awaited<ReturnType<typeof promotionMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof promotionMeRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPromotionMeRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Provides the top 40 rake race scores for August 2025.
If the user is authenticated, it also includes their score and rank.
 * @summary Get Rake Race Leaderboard
 */
export const promotionRakeRaceRetrieve = (signal?: AbortSignal) => {
  return promotionRakeRaceRetrieveMutator<RakeRaceResponse>({
    url: `/api/v1/promotion/rake-race/`,
    method: 'GET',
    signal,
  })
}

export const getPromotionRakeRaceRetrieveQueryKey = () => {
  return [`/api/v1/promotion/rake-race/`] as const
}

export const getPromotionRakeRaceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPromotionRakeRaceRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>> = ({
    signal,
  }) => promotionRakeRaceRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PromotionRakeRaceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>
>
export type PromotionRakeRaceRetrieveQueryError = unknown

export function usePromotionRakeRaceRetrieve<
  TData = Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
        TError,
        Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePromotionRakeRaceRetrieve<
  TData = Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
        TError,
        Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePromotionRakeRaceRetrieve<
  TData = Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Rake Race Leaderboard
 */

export function usePromotionRakeRaceRetrieve<
  TData = Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPromotionRakeRaceRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getPromotionRakeRaceRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPromotionRakeRaceRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>> = ({
    signal,
  }) => promotionRakeRaceRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PromotionRakeRaceRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>
>
export type PromotionRakeRaceRetrieveSuspenseQueryError = unknown

export function usePromotionRakeRaceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePromotionRakeRaceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePromotionRakeRaceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Rake Race Leaderboard
 */

export function usePromotionRakeRaceRetrieveSuspense<
  TData = Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof promotionRakeRaceRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPromotionRakeRaceRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
